import { useContext, useState } from 'react'
import ColorIcon from './ColorIcon'
import { stateContext } from './ctx'
import { icons } from './icons'
import Picker from './Picker'

const BgColor = () => {
    const {bgColor,setBgColor} = useContext(stateContext)
    const [open,setOpen] = useState(false)

    const changeColor = e => {
        let a = e.hsl
        a = 'hsla('+parseInt(a.h)+','+parseInt(100*a.s)+'%,'+parseInt(100*a.l)+'%,'+a.a+')';
        setBgColor(a)
    }


    
    return <div className='flex flex-col p-3'>
        <div className='flex items-center justify-between h-10 gap-3'>
            <div className='minititle items-center flex '>Bg Color</div>
            <div className='h-12 flex-1 flex items-center px-2 gap-2 rounded-xl bg-mute-100 font-semibold dark:bg-slate-800 cursor-pointer' onClick={()=>setOpen(!open)}>
                <ColorIcon value={bgColor} className='rounded-md w-8 h-8' />
                <span>{bgColor}</span>
                <div className='ml-auto btn'>{icons.arrowDown}</div>
            </div>
        </div>
        {open ? <div className='bg-mute-100 dark:bg-slate-800 p-3 mt-3 rounded-xl'>
            <Picker color={bgColor} onChange={changeColor} hasInput={true} />
        </div> : []}
        
    </div>

    
}

export default BgColor